export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual.aria-label',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.percentual.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    lessThanOrEquals: {
      id: 'admin/promotions.form.validation.less-than-equals',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
